import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";

// import RSILogo from "../../assets/images/gus-rsi-logo-horizontal.png";
import RSILogoPL from "../../assets/images/gus-rsi-logo-horizontal-pl.png";
import RSILogoEN from "../../assets/images/gus-rsi-logo-horizontal-en.png";

// import '../../assets/fonts/FiraSans/FiraSans-Regular-normal'
// import '../../assets/fonts/FiraSans/FiraSans-Bold-bold'

import "./assets/fonts/Roboto-Regular-normal";
import "./assets/fonts/Roboto-Bold-normal";
// import './assets/fonts/Roboto-BoldItalic-normal';
// import './assets/fonts/Roboto-Italic-normal';

// import '../../../assets/fonts/Roboto/Roboto-Regular-normal'
// import '../../../assets/fonts/Roboto/Roboto-Bold-normal'

const addFooters = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();

    // doc.setFont('Fira Sans', 'normal')
    doc.setFont("Roboto-Regular", "normal");
    doc.setFontSize(8);
    for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setDrawColor(0);
        doc.setFillColor(0, 29, 119);
        doc.rect(0, doc.internal.pageSize.height - 6, doc.internal.pageSize.width, doc.internal.pageSize.height, "F");
        doc.setTextColor(255, 255, 255);

        doc.text(
            String(i) + "/" + String(pageCount),
            doc.internal.pageSize.width - 10,
            doc.internal.pageSize.height - 2,
            {
                align: "right",
            }
        );
        doc.text(
            `Opracowanie wygenerowane z systemu RSI w dn. ${moment().format(
                "DD.MM.YYYY"
            )} r. na podstawie ustawień użytkownika.`,
            10,
            doc.internal.pageSize.height - 2,
            {
                align: "left",
            }
        );
    }
};

const strip = (html) => {
    if (html == null) return "";
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
};

export const generatePDF = ({ data, gestors, lang = "pl" }) => {
    // console.log({ data, lang });

    var doc = new jsPDF("p", "mm", "a4");
    doc.setDocumentProperties({
        title: "RSI",
        subject: "Systemy informacyjne RSI",
        author: "GUS",
        keywords: "report,Systemy, informacyjne, RSI",
        creator: "RSI",
        created: moment().format("DD.MM.YYYY HH:mm:ss"),
        modified: moment().format("DD.MM.YYYY HH:mm:ss"),
        producer: "RSI",
    });
    doc.setLanguage("pl");
    // doc.setFont('Fira Sans', 'normal')
    doc.setFont("Roboto-Regular", "normal");
    // doc.setFont('Roboto-Regular', 'normal')

    /** Title */
    if (lang === "en") {
        doc.addImage(RSILogoEN, "PNG", 10, 10, 290 / 3.78, 44 / 3.78, "RSILogo");
    }else{
        doc.addImage(RSILogoPL, "PNG", 10, 10, 290 / 3.78, 44 / 3.78, "RSILogo");
    }

    doc.setFontSize(13);
    var splittedText = doc.splitTextToSize("Systemy informacyjne objęte RSI", doc.internal.pageSize.getWidth() - 115);
    doc.text(splittedText, 100, 20);

    doc.setLineWidth(0.1);
    doc.setDrawColor(204, 204, 204);
    doc.line(15, 35, doc.internal.pageSize.getWidth() - 15, 35);

    doc.setFontSize(10);

    let yPos = 45;

    data.forEach((system, i) => {
        // console.log(system.id_systemu)

        if (i > 0) {
            // doc.addPage()
            // yPos = 15
            // console.log(doc.lastAutoTable.finalY, doc.internal.pageSize.getHeight());

            yPos = doc.lastAutoTable.finalY ? doc.lastAutoTable.finalY + 0 : yPos;

            doc.setLineWidth(0.1);
            doc.setDrawColor(204, 204, 204);

            doc.line(15, yPos, doc.internal.pageSize.getWidth() - 15, yPos);

            yPos += 5;
        } else {
            yPos = doc.lastAutoTable.finalY ? doc.lastAutoTable.finalY + 20 : yPos;
        }

        doc.autoTable({
            html: `#reportData-table-${system.id_systemu}`,
            margin: { left: 10, right: 1 },
            startY: yPos,
            tableWidth: "auto",
            columnWidth: "wrap",

            // pageBreak: 'auto',
            // rowPageBreak: 'avoid',
            styles: {
                lineColor: [255, 255, 255],
                lineWidth: 0,
                font: "Roboto-Regular",
                overflow: "linebreak",
                cellPadding: { top: 1, right: 1, bottom: 1, left: 1 },
                // fontSize: 10,
                fontSize: 11,
                rowPageBreak: "avoid",
                minCellHeight: 4, //8,
            },
            bodyStyles: {},
            theme: "grid",
            willDrawCell: (data) => {
                if (data.cell.raw) {
                    doc.setFontSize(
                        !isNaN(parseFloat(data.cell.raw.style.fontSize))
                            ? parseFloat(data.cell.raw.style.fontSize)
                            : // ?12
                              10
                    );

                    data.cell.styles.fontSize = !isNaN(parseFloat(data.cell.raw.style.fontSize))
                        ? parseFloat(data.cell.raw.style.fontSize)
                        : // ?10
                          12;

                    // doc.setFont('Fira Sans', data.cell.raw.style.fontWeight ? data.cell.raw.style.fontWeight : 'normal')
                    data.cell.raw.style.fontWeight && data.cell.raw.style.fontFamily
                        ? doc.setFont(data.cell.raw.style.fontFamily, "normal")
                        : doc.setFont("Roboto-Regular", "normal");
                }
            },
            didDrawCell: (data) => {
                if (data.cell.raw) {
                    doc.setFontSize(
                        !isNaN(parseFloat(data.cell.raw.style.fontSize))
                            ? parseFloat(data.cell.raw.style.fontSize)
                            : // ?12
                              10
                    );
                }
            },
        });
    });
    addFooters(doc);

    doc.save(`RSI_report_${moment().format("DDMMYYYY_HHmmss")}.pdf`);

    return;

    // eslint-disable-next-line
    data.forEach((system, i) => {
        let theWSKBody = [];

        theWSKBody.push([
            {
                styles: {
                    halign: "left",
                    valign: "top",
                    fontSize: 10,
                    fontStyle: "bold",
                    cellWidth: 7,
                    minCellWidth: 7,
                },
                content: "ID:",
            },
            { styles: { halign: "left", valign: "top" }, content: system.id_systemu },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Nazwa systemu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 12, fontStyle: "bold" },
                content: strip(system.nazwa_systemu),
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "rileftght", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Skrócona nazwa:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            { styles: { halign: "left", valign: "top" }, content: strip(system.nazwa_systemu_skr), colSpan: 2 },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Gestor:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([{ styles: { halign: "left", valign: "top" }, content: strip(system.gestor), colSpan: 2 }]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Podstawa prawna:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content:
                    "<1 Tytuł (Adres publikacyjny)>\n<2 Tytuł (Adres publikacyjny)>\n<N Tytuł (Adres publikacyjny)>",
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Cel systemu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([{ styles: { halign: "left", valign: "top" }, content: "<Cel systemu> ", colSpan: 2 }]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Sposób prowadzenia systemu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content: "<Sposób prowadzenia systemu: centralny, rozproszony, województwo, powiat, gmina, inny>",
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Zasięg systemu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([{ styles: { halign: "left", valign: "top" }, content: "<Zasięg systemu>", colSpan: 2 }]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Forma prowadzenia systemu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            { styles: { halign: "left", valign: "top" }, content: "<Forma prowadzenia systemu>", colSpan: 2 },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Źródła danych i częstotliwość aktualizacji:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content: "<Źródła danych i częstotliwość aktualizacji>",
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Termin i formy udostępniania danych:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content: "<Termin i formy udostępniania danych> ",
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Stan wdrożenia systemu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            { styles: { halign: "left", valign: "top" }, content: "<Stan wdrożenia systemu>", colSpan: 2 },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Zmiany planowane do wprowadzenia w systemie:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            { styles: { halign: "left", valign: "top" }, content: "<Zmiany planowane w systemie]> ", colSpan: 2 },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Planowany termin wdrożenia:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            { styles: { halign: "left", valign: "top" }, content: "<Planowany termin wdrożenia>", colSpan: 2 },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Nazwa obiektu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([{ styles: { halign: "left", valign: "top" }, content: "<Nazwa obiektu 1>", colSpan: 2 }]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Typ obiektu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content:
                    "<Typ obiektu 1: osoba fizyczna, osoba fizyczna prowadząca działalność gospodarczą (przedsiębiorca) lub rolniczą, podmiot, obiekt przestrzenny, inny>",
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Opis obiektu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([{ styles: { halign: "left", valign: "top" }, content: "<Opis obiektu 1>", colSpan: 2 }]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Standardowe identyfikatory obiektu:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content:
                    "<Standardowe identyfikatory obiektu 1: numer PESEL, numer identyfikacyjny REGON, numer identyfikacji podatkowej NIP, numer KRS, identyfikator punktu adresowego, identyfikator działki ewidencyjnej, identyfikatory jednostek podziału administracyjnego (TERYT), identyfikatory miejscowości (TERYT), identyfikatory ulic (TERYT)>",
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Nazwa cechy informacyjnej:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content: "<Nazwa cechy informacyjnej 1 opisującej obiekt 1>",
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Definicja cechy informacyjnej:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content: "<Definicja cechy informacyjnej 1 opisującej obiekt 1>",
                colSpan: 2,
            },
        ]);

        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top", fontSize: 10, fontStyle: "bold" },
                content: "Normatywne źródło definicji cechy informacyjnej:",
                colSpan: 2,
            },
        ]);
        theWSKBody.push([
            {
                styles: { halign: "left", valign: "top" },
                content: "<Tytuł (Adres publikacyjny) cechy informacyjnej 1 opisującej obiekt 1>",
                colSpan: 2,
            },
        ]);

        doc.autoTable({
            head: [],
            body: theWSKBody,
            margin: { left: 10 },
            startY: yPos, // (doc.internal.pages.length - 1) * doc.internal.pageSize.getHeight() + 10,
            tableWidth: "auto",
            columnWidth: "wrap",
            columnStyles: [{ cellWidth: "auto", minCellWidth: 48 }, { cellWidth: "auto" }],
            pageBreak: "auto",
            rowPageBreak: "avoid",
            // columnStyles,
            styles: {
                lineColor: [255, 255, 255],
                lineWidth: 0,
                font: "Fira Sans",
                // font: 'Roboto-Regular',
                tableWidth: "auto",
                overflow: "linebreak",
            },
            headStyles: {
                fillColor: [250, 250, 250],
                textColor: 0,
                fontSize: 10,
                halign: "center",
                valign: "middle",
            },
            footStyles: {
                fillColor: [241, 196, 15],
                fontSize: 10,
            },
            bodyStyles: {
                fillColor: [255, 255, 255],
                textColor: 0,
                fontSize: 10,
                rowPageBreak: "avoid",
                cellPadding: { top: 1, right: 1, bottom: 1, left: 1 },
                lineColor: [255, 255, 255],
                lineWidth: 0,
            },
            theme: "grid",
        });

        if (data.length > 1) {
            doc.addPage();
            yPos = 15;
        }
    });

    // eslint-disable-next-line
    addFooters(doc);

    // eslint-disable-next-line
    doc.save(`RSI_report_${moment().format("DDMMYYYY_HHmmss")}.pdf`);
};
